import Brightcove from './libs/brightcove'
import PeachAPI from './libs/peach'
import Tg4 from './libs/tg4'
import CMS from './libs/cms'

export default {
  'Brightcove': new Brightcove(),
  'Tg4': new Tg4(),
  'PeachAPI': new PeachAPI(),
  'CMS': new CMS()
}